import * as React from 'react';
import { Component, Fragment } from 'react';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import { inject } from '../utils';
import { withTheme } from 'styled-components';
import { styled } from '../utils/styled';
import { propStyles } from '../utils/propStyles';
import Icon from './Icon';
import { translate } from './Translate';
import { TranslationStore } from '../stores';
import { Theme } from '../models/Theme';

const StarRatingWrapper = styled<any, any>(
    'div',
    'starRatingWrapper',
    'starRating'
)`
    ${propStyles};
`;

StarRatingWrapper.defaultProps = {
    display: 'flex',
};

const StarIcon = styled<any, any>(Icon, 'starIcon', 'starRating')`
    ${propStyles};
`;

StarIcon.defaultProps = {
    height: '1em',
    width: '1em',
};

const StarOutlineIcon = styled<any, any>(Icon, 'starOutlineIcon', 'starRating')`
    ${propStyles};
`;

StarOutlineIcon.defaultProps = {
    height: '1em',
    width: '1em',
};

const StarRatingContentWrapper = styled<any, any>(
    'div',
    'starRatingContentWrapper',
    'starRating'
)`
    ${propStyles};
`;

interface StarRatingProps {
    translationStore?: TranslationStore;
    theme?: Theme;
    showEmptyStars?: boolean;
    maxRating?: number;
    rating: number | string;
    display?: string;
    noDataPlaceholder?: string;
}
@inject('translationStore')
@observer
class StarRating extends Component<StarRatingProps> {
    constructor(props) {
        super(props);
    }

    @computed
    get ratingNumber() {
        const { rating = 0 } = this.props;
        return parseInt(rating as any, 10);
    }

    @computed
    get ratingText() {
        const { rating = 0, noDataPlaceholder, translationStore } = this.props;
        // If we are not able to get a number, display the rating value
        // In this case it is likely to be a no data placeholder
        // use placeholder if rating equals 0
        if (isNaN(this.ratingNumber) || this.ratingNumber === 0) {
            // use placeholder if no rating or rating is empty
            if (noDataPlaceholder) {
                return translate(translationStore, noDataPlaceholder);
            }
            return translate(translationStore, rating);
        }
    }

    @computed
    get starRatingContent() {
        const { maxRating = 5, showEmptyStars, theme } = this.props;

        // show placeholder if ratingNumber is not valid
        if (this.ratingText) {
            return this.ratingText;
        }

        const stars = Array.from(Array(this.ratingNumber).keys()).slice(
            0,
            maxRating
        );
        const emptyStars = showEmptyStars
            ? Array.from(Array(maxRating).keys())
            : [];
        return (
            <Fragment>
                {stars.map((star, idx) => {
                    const altTextRating =
                        idx === 0 ? `${stars.length} of 5` : '';
                    const disableAltText = idx !== 0;
                    return (
                        <StarIcon
                            key={idx}
                            fileName="MorningstarIcon"
                            {...theme.StarIcon}
                            accessibilityContext={altTextRating}
                            disableAltText={disableAltText}
                        />
                    );
                })}
                {emptyStars.slice(stars.length).map((emptyStar, idx) => {
                    return (
                        <StarOutlineIcon
                            key={idx}
                            fileName="MorningstarOutlineIcon"
                            {...theme.StarOutlineIcon}
                        />
                    );
                })}
            </Fragment>
        );
    }

    render() {
        const { starRatingContent, props } = this;
        const { theme } = props;

        return (
            <StarRatingWrapper
                {...props}
                {...theme.StarRatingWrapper}
                role="text"
                aria-label={`${this.ratingText || this.ratingNumber}`}
            >
                <StarRatingContentWrapper aira-hidden={true}>
                    {starRatingContent}
                </StarRatingContentWrapper>
            </StarRatingWrapper>
        );
    }
}

export default withTheme(StarRating);



// WEBPACK FOOTER //
// ./src/Components/StarRating.tsx